// « Forcer sans avance » (owner, 2026-10-15): the worker refuses every printing
// status (ready-to-print, in-production, printed) until the advance is received
// (worker lib/printAdvanceGate.ts) and answers 409 { code: 'not_paid' }. An
// ADMIN may send it on anyway with a written reason — logged on the order with
// who, when and why. Staff only see the refusal.

/** Is this error the advance gate's refusal? */
export function isNotPaid(err: unknown): boolean {
  const e = err as { status?: number; body?: { code?: string } } | null;
  return e?.status === 409 && e?.body?.code === 'not_paid';
}

/** The shortest reason the worker accepts (lib/printAdvanceGate.ts MIN_OVERRIDE_REASON). */
export const MIN_REASON = 5;

/**
 * Ask the admin for the reason. Null = cancelled. Asks again while the reason
 * is too short to mean anything.
 */
export function askOverrideReason(refusal: string, ask: (msg: string) => string | null = (m) => window.prompt(m)): string | null {
  let msg = `${refusal}\n\nForcer sans avance ? Écrivez la raison (obligatoire, gardée sur la commande) :`;
  for (let i = 0; i < 3; i += 1) {
    const r = ask(msg);
    if (r == null) return null;
    if (r.replace(/\s+/g, ' ').trim().length >= MIN_REASON) return r.trim();
    msg = `Raison trop courte (${MIN_REASON} caractères minimum).\n\n${refusal}\n\nRaison :`;
  }
  return null;
}
